<template>
  <div class="container portfolio page" ref="page" @click="onPageClick" @keydown="onPageKeydown">
    <div class="row">
      <div class="body-pane col-lg-12">
        <div class="content">
          <hgroup>
            <h2>Portfolio Projects</h2>
          </hgroup>
          <div class="container gallery">
            <p>Many apps I have worked on are internally-facing or behind a login wall. Nonetheless, here are some screenshots of applications I have worked on that are publically accessibile and a break down about my contributions.</p>
            <div class="row ">
              <hgroup class="mt-3">
                <h3><strong>USA Small Business Admin</strong></h3>
                <p>Production Site: <a href="https://lending.sba.gov/" target="_blank" rel="noopener">My SBA Loan Portal<span class="visually-hidden"> (opens in new tab)</span></a></p>
              </hgroup>
              <div class="col-lg-6">
                <h4>My Contribution</h4>
                <p>This was a Vue project. I worked on assembling the markup and styling structure for all prototype componets. I levereged Bootstrap for some standard elements and customized much of the HTML, CSS, JavaScript based on PDF/XD documents from the UX design team.</p>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/sba/create_loan.webp" width="100%" />
                  <figcaption>This is where the User would enter information for a new loan while also seeing relevant info on the right panel.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/sba/main_queue_mobile_collapse.webp" width="100%" />
                  <figcaption>Mobile presentation of the previous screen. The menu could also be collapsed to show only icons.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/sba/loan_batches.webp" width="100%" />
                  <figcaption>The User creates a batch of loans and gets an error message.</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="container gallery">
            <div class="row ">
              <hgroup class="mt-3">
                <h3><strong>County of San Bernardino, Information Services Department</strong></h3>
                <p>Production Site: <a href="https://animalcare.sbcounty.gov/contactus/" target="_blank" rel="noopener">County Animal Care<span class="visually-hidden"> (opens in new tab)</span></a></p>
              </hgroup>
              <div class="col-lg-6">
                <h4>My Contribution</h4>
                <p>There were many projects with the County. This particular one was a WordPress project. The idea was to assemble the components so they could be easily altered without messing with code or risking breaking the site. That said, I was not the designer. I basically set up the site installation so that people who work there could be the ones to alter the content.</p>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/isd/contact-us.webp" width="100%" />
                  <figcaption>This is the "Contact Us" page and the department itself has full control over managing content.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/isd/foster-pet.webp" width="100%" />
                  <figcaption>These paricault images and information did not exist when I was there, which tells me the site is thriving and the County employees are able to alter content.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/isd/pet-search.webp" width="100%" />
                  <figcaption>This is the Pet Search tool.</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="container gallery">
            <div class="row ">
              <hgroup class="mt-3">
                <h3><strong>Royal Hawaiian Center Site (via PlaceWise Digital)</strong></h3>
                <p>Production Site: <a href="https://www.royalhawaiiancenter.com/" target="_blank" rel="noopener">Royal Hawaiian Center<span class="visually-hidden"> (opens in new tab)</span></a></p>
              </hgroup>
              <div class="col-lg-6">
                <h4>My Contribution</h4>
                <p>This was a lot of raw, vanilla HTML, CSS and JavaScript. There was a large PDF document that was designed by a 3rd party. That document served as a guide to assemble the look and feel of several components.  PlaceWise Digital maintaines several sites for brick-and-mortar malls. This one was by the far the most elaborate and involved.</p>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/pw/rh_home.webp" width="100%" />
                  <figcaption>This is the main landing page with HTML5 video.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/pw/rh_dining.webp" width="100%" />
                  <figcaption>This is the dining search directory.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/pw/rh_events.webp" width="100%" />
                  <figcaption>Upcoming Events Information</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="container gallery">
            <div class="row ">
              <hgroup class="mt-3">
                <h3><strong>TOMS Shoes</strong></h3>
                <p>Production Site: <a href="https://www.toms.com/nl-nl" target="_blank" rel="noopener">TOMS Shoes, Netherlands<span class="visually-hidden"> (opens in new tab)</span></a></p>
              </hgroup>
              <div class="col-lg-6">
                <h4>My Contribution</h4>
                <p>When I first started, I was helping maintain the older Magento sites for USA, Canada, UK. Then we started working on expanding the stores to Europe, starting with the Netherlands as the pilot. I was responsible for writing the inital HTML, CSS, JavaScript based on a 3rd party PDF design document.  Much of what I have written has evolved since 2013, but the site thrives and much of the initial design has survived.</p>
                <p>This is also intended to be language agnostic so content can easily switch to French, German, English, etc.</p>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/toms/toms_main.webp" width="100%" />
                  <figcaption>This is the main landing page.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/toms/toms_gallery.webp" width="100%" />
                  <figcaption>Standard gallery, very easy to use.</figcaption>
                </figure>
              </div>
              <div class="col-lg-6 mb-3">
                <figure class="screenshots">
                  <img src="../assets/screens/toms/toms_mens_detail.webp" width="100%" />
                  <figcaption>Details and options for most items.</figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="current"
      class="lightbox"
      ref="lightbox"
      role="dialog"
      aria-modal="true"
      :aria-label="current.caption"
      @click.self="close"
    >
      <button type="button" class="lightbox-close" ref="closeBtn" aria-label="Close" @click="close">&times;</button>
      <button type="button" class="lightbox-prev" aria-label="Previous image" @click="step(-1)">&#8249;</button>
      <figure>
        <img :src="current.src" :alt="current.alt" />
        <figcaption>
          {{ current.caption }}
          <span class="lightbox-count">{{ index + 1 }} / {{ images.length }}</span>
        </figcaption>
      </figure>
      <button type="button" class="lightbox-next" aria-label="Next image" @click="step(1)">&#8250;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortfolioView',
  data() {
    return {
      images: [],
      index: -1,
      lastFocus: null,
    };
  },
  computed: {
    current() {
      return this.images[this.index] || null;
    },
  },
  mounted() {
    // collect every screenshot on the page and make it keyboard-openable
    const imgs = this.$refs.page.querySelectorAll('.screenshots img');
    this.images = Array.from(imgs, (img, i) => {
      const caption = img.parentElement.querySelector('figcaption');
      // short alt from the project heading; the figcaption carries the description,
      // so repeating it in alt would make screen readers read it twice
      const heading = img.closest('.gallery') && img.closest('.gallery').querySelector('h3');
      const label = heading ? `Screenshot: ${heading.textContent.trim()}` : 'Screenshot';
      img.dataset.lightboxIndex = i;
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.alt = img.alt || label;
      return { src: img.src, alt: img.alt, caption: caption ? caption.textContent.trim() : '' };
    });
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  },
  methods: {
    onPageClick(e) {
      const i = e.target.dataset && e.target.dataset.lightboxIndex;
      if (i !== undefined) this.open(Number(i));
    },
    onPageKeydown(e) {
      // thumbnails act as buttons, so open on Enter or Space
      if ((e.key === 'Enter' || e.key === ' ') && e.target.dataset.lightboxIndex !== undefined) {
        e.preventDefault();
        this.open(Number(e.target.dataset.lightboxIndex));
      }
    },
    open(i) {
      this.lastFocus = document.activeElement;
      this.index = i;
      document.body.style.overflow = 'hidden';
      this.$nextTick(() => this.$refs.closeBtn && this.$refs.closeBtn.focus());
    },
    close() {
      this.index = -1;
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    },
    step(dir) {
      const n = this.images.length;
      this.index = (this.index + dir + n) % n;
    },
    onKeydown(e) {
      if (!this.current) return;
      if (e.key === 'Escape') this.close();
      else if (e.key === 'ArrowLeft') this.step(-1);
      else if (e.key === 'ArrowRight') this.step(1);
      else if (e.key === 'Tab') this.trapFocus(e);
    },
    trapFocus(e) {
      // keep Tab cycling through the lightbox buttons while it is open
      const buttons = Array.from(this.$refs.lightbox.querySelectorAll('button'));
      const first = buttons[0];
      const last = buttons[buttons.length - 1];
      if (!buttons.includes(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },
  },
}
</script>

